import {
    ADD_ITV_MAQUINA,
    DELETE_ITV_MAQUINA,
    MODIFY_ITV_MAQUINA
} from '../constants/action_types';

export function addItvDeMaquina(itv) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_ITV_MAQUINA, payload: itv });
    };
};

export function modifyItvMaquina(itv) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_ITV_MAQUINA, payload: itv });
    };
};


export function removeItvDeMaquina(itv) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_ITV_MAQUINA, payload: itv });
    };
};